import styled from 'styled-components';
import { Box } from '../../layout/Box';

interface GridContainerProps {
    isMobile: boolean | null;
}

export const GridContainer = styled(Box)
    .withConfig({ displayName: 'GridContainer' })
    .attrs((props) => ({
        ...props,
        display: 'grid',
    }))<GridContainerProps>`
    row-gap: 10px;
    column-gap: 10px;
    grid-template-columns: ${({ isMobile }) => (isMobile === false ? '1fr 1fr 1fr' : '1fr 1fr')};
`;
